import { useSwagger } from '../SwaggerProvider';

const useAuthorizeSwagger = () => {
  const { swagComp } = useSwagger();

  return (vccApiKey: string, accessToken: string) => {
    if (!swagComp) throw new Error('No swagger component');

    swagComp.preauthorizeApiKey('apiKeyHeader', vccApiKey);
    swagComp.preauthorizeApiKey('accessToken', accessToken);
  };
};

export default useAuthorizeSwagger;
